<template>
  <v-list-tile class="c-talk-list-tile" :class="{ selected: currentTalkId == talk.id }" avatar @click="onClick">
    <v-list-tile-avatar class="c-avatar c-cover-40">
      <v-badge color="red" right bottom overlap v-model="badge">
        <template v-slot:badge>
          <span>{{ unreadCount }}</span>
        </template>
        <div class="c-avatar c-cover-40">
          <c-img v-if="cms" :src="coverPath" />
        </div>
      </v-badge>
    </v-list-tile-avatar>
    <v-list-tile-content>
      <v-list-tile-title class="c-ttl"
        ><span v-if="cms">{{ talkName }}</span></v-list-tile-title
      >
      <v-list-tile-sub-title class="c-sub-ttl">
        <talk-msg-for-latest :value="talk.last_msg" />
      </v-list-tile-sub-title>
    </v-list-tile-content>
    <v-list-tile-action class="c-chip">
      <div class="c-time">{{ fmtTime }}</div>
      <cmid-avatar
        class="c-avt"
        :cmid="talk.last_cmid ? talk.last_cmid : talk.cmid"
        :cid="talk.cid"
        :pos="1"
        :elevation="1"
        type="talk"
        :typeId="talk.id"
        :friends="curFriends"
      />
    </v-list-tile-action>
  </v-list-tile>
</template>

<script>
import talkPlugin from '../../utils/plugin/talkPlugin';
import talkMsgForLatest from './TalkMsgForLatest.vue';

export default {
  mixins: [talkPlugin],
  components: {
    'talk-msg-for-latest': talkMsgForLatest,
  },
  props: {
    talk: { type: Object, required: true },
    friends: { type: Object, required: false },
  },
  data() {
    return {
      badge: false,
      cms: null,
      curFriends: this.friends || {},
    };
  },
  mounted() {
    this.badge = !!this.unreadCount;
    this.resetCms(this.cid);
  },
  watch: {
    unreadCount(n, o) {
      this.badge = !!n;
    },
    cid(n, o) {
      if (n != o) {
        this.resetCms(n);
      }
    },
  },
  computed: {
    cid() {
      return this.talk.cid;
    },
    otherCmid() {
      return this.calcOtherUserCmid(this.talk);
    },
    unreadCount() {
      var c = this.talk.last_num - (this.talk.read_num ? this.talk.read_num : 0);
      if (c >= 100) return '99+';
      else if (c > 0) return c;
      else if (this.talk.read_num == null) return 'new';
      return null;
    },
    talkName() {
      return this.getTalkName(this.talk, this.cms);
    },
    coverPath() {
      return this.getTalkCoverPath(this.talk, this.cms);
    },
    selectedTalk() {
      return this.$store.getters.selectedTalk;
    },
    currentTalkId() {
      return this.$store.state.talk.talk ? this.$store.state.talk.talk.id : 0;
    },
    fmtTime() {
      return this.diffDateFormatShort(this.$moment.unix(this.talk.last_tstamp));
    },
  },
  methods: {
    onClick() {
      this.$emit('click', this.talk);
    },
    resetCms(cid) {
      this.cms = null;
      var self = this;
      this.getAllGroupsAndMembers(cid, function(data) {
        self.cms = data.cms;
      });
    },
  },
};
</script>

<style scoped>
.c-list {
  height: calc(100vh - 222px);
  overflow: scroll;
}
.le-tbs .c-list {
  height: calc(100vh - 156px);
}
.le-sp .c-list {
  height: initial !important;
  padding-bottom: 60px;
}
.c-talk-list {
  padding: 0;
}
.c-avatar {
  min-width: 55px;
  max-width: 55px;
  height: 100%;
  margin: 0 0 0 -5px !important;
  display: flex;
  justify-content: center;
  align-items: center;
}
.c-div {
  margin-left: 65px;
  max-width: calc(100% - 65px);
}
.c-chip {
  max-width: 35px;
  min-width: 35px;
}
.c-chip .c-time {
  position: absolute;
  top: 2px;
  right: 8px;
  font-size: 11px;
  color: rgba(0, 0, 0, 0.54);
}
.c-avt {
  position: absolute;
  bottom: 5px;
  right: 12px;
  opacity: 0.9;
}
.c-ttl {
  font-size: 15px;
}
.c-sub-ttl {
  min-height: 15px;
  max-height: 30px;
  overflow-y: hidden !important;
  font-size: 12px !important;
  line-height: 15px;
  margin-top: 1px;
}
</style>
